// CRUD de períodos acadêmicos
import { collection, doc, addDoc, updateDoc, getDocs, writeBatch } from "firebase/firestore";
import { db, PERIODS_COL, periodBase } from './config';

export async function createPeriod(label: string, startDate: string, endDate: string): Promise<string> {
  if (startDate && endDate && endDate < startDate) throw new Error('Data de fim não pode ser anterior à data de início.');
  const ref = await addDoc(collection(db, PERIODS_COL), { label, startDate, endDate, active: false, createdAt: new Date() });
  return ref.id;
}

export async function activatePeriod(pid: string, allIds: string[]) {
  const batch = writeBatch(db);
  for (const id of allIds) batch.update(doc(db, PERIODS_COL + "/" + id), { active: id === pid });
  await batch.commit();
}

export async function closePeriod(pid: string) {
  await updateDoc(doc(db, PERIODS_COL + "/" + pid), { active: false, closed: true });
  const studSnap = await getDocs(collection(db, periodBase(pid) + "/students"));
  const batch = writeBatch(db);
  studSnap.docs.forEach(d => batch.delete(d.ref));
  const sessSnap = await getDocs(collection(db, periodBase(pid) + "/sessions"));
  sessSnap.docs.forEach(d => batch.delete(d.ref));
  await batch.commit();
}

export async function updatePeriodTotalAulas(pid: string, total: number) {
  await updateDoc(doc(db, PERIODS_COL + "/" + pid), { totalAulas: total });
}
